module.exports = __webpack_public_path__ + "static/media/clock-icon.092cac96.svg";